import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ErrorView } from '@americanexpress/commercial-ux-components';

const NoProducts = () => (
  <ErrorView
    heading={<FormattedMessage id="noProducts.heading" />}
    details={
      <span data-testid="error-details">
        <FormattedMessage id="noProducts.details" />
      </span>
    }
    actionButton={false}
  />
);

export default NoProducts;
